import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

import { ref, onMounted } from 'vue';  

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
import { useI18n } from 'vue-i18n';
import { useStore }   from 'vuex';
import { getBandWidthDataByIp } from '@/services/RAOS/Graphs';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS } from '@/constants/labels';
import { COLOR } from '@/constants/colors';


/********************************
 ********** COMPONENTS **********
 *******************************/
import SingleChart from '@/components/SmartLink/charts/SingleChart.vue';
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RAOS',
  props: {
    title   :{ required:true },
    ip      :{ required:true, type:String },
},
  setup(__props) {

const props = __props;


const { xs } = useDisplay();


/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 ************ STORE *************
 *******************************/
const store  = useStore();

/********************************
 *********** SERVICES ***********
 *******************************/
 


const showGraphs    = ref(false); 


const finalItemBandWidth  = ref();

async function getAllBandWidthByIP() {

    
    const params = {
        ip : props.ip
    }
    const allData = await getBandWidthDataByIp(params)

    if( allData.status === 400 ){
        showGraphs.value = allData.showGraphs
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        showGraphs.value = allData.showGraphs        
        finalItemBandWidth.value = allData.data
    }

}


onMounted( async() => {
    getAllBandWidthByIP();
    console.log('RAOS BANDWIDTH MOUNTED')
})


return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "ma-0" }, {
    default: _withCtx(() => [
      (showGraphs.value)
        ? (_openBlock(), _createBlock(_component_v_col, {
            key: 0,
            cols: "12",
            class: "pa-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_sheet, {
                class: _normalizeClass([_unref(xs)?'card-dialogs-graph-wop':'card-dialogs-graph', "mb-4"]),
                color: "bgtopology"
              }, {
                default: _withCtx(() => [
                  (finalItemBandWidth.value.length !== 0)
                    ? (_openBlock(), _createBlock(SingleChart, {
                        key: 0,
                        name: 'Ancho Banda',
                        "first-array": finalItemBandWidth.value,
                        title: "Ancho de Banda",
                        color: _unref(COLOR).single
                      }, null, 8, ["first-array", "color"]))
                    : (_openBlock(), _createBlock(_component_v_sheet, {
                        key: 1,
                        class: "text-center",
                        color: "transparent"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(Prog_circular)
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})